import { WidgetColumn } from "@bryntum/grid-thin";

export class VisitBookColumn extends WidgetColumn {
  static get type() {
    return "visitBook";
  }

  // @ts-ignore - Bryntum 7.x declares widgets as a property, but we need to override as accessor
  override get widgets() {
    return [
      {
        type: "button",
        text: "Book",
        icon: "b-fa b-fa-clock",
        color: "blue",
        cls: "b-raised",
        width: 80,
        onAction: ({ source: btn }) => {
          console.log("default visitBook widget firing");
          // @ts-ignore
          this.grid.trigger("visitBook", {
            type: "visitBook",
            record: btn.cellInfo.record
          });
        }
      }
    ];
  }
}
